<template>
  <div>
    <a href="https://www.iucn.org/"> <span class="popup-close">+</span> </a>
    <div class="left-panel">
      <div class="left-inner">
        <div class="language-switch-container">
          <locale-switch></locale-switch>
        </div>
        <!-- <div class="lp-signup">
          <p>{{$t("auth.register__top_line")}}</p>
          <router-link to="/auth/login" class="btn btn-primary btn-simple">{{$t("auth.btn_login")}}</router-link>
        </div> -->

        <h1>{{ $t("auth.forgot__title") }}</h1>
        <h3>{{ $t("auth.forgot__subtitle_reset") }}</h3>

        <form v-if="!submitted" @submit.prevent="submitResetPassword">
          <div>
          <span class="lp-form-input">
            <input type="text"
                   v-model="model.email"
                   v-validate="'required|email'"
                   name="email"
                   class="form-control"
                   :class="{ 'has-danger': getError('email') }"
            />
            <label for="email">{{ $t('auth.input_email') }}</label>
                        <span v-if="getError('email')" class="has-error">{{getError('email')}}</span>
            </span>

            <span class="lp-form-input">
               <input type="password"
                      v-model="model.password"
                      v-validate="'required|min:5'"
                      data-vv-as="password"
                      name="password"
                      class="form-control"
                      :class="{ 'has-danger': getError('password') }"
                      ref="password"
               />
            <label for="password">{{ $t('auth.input_password') }}</label>
              <span v-if="getError('password')" class="has-error">{{ getError('password') }}</span>
          </span>


            <span class="lp-form-input">
               <input type="password"
                      v-model="model.passwordConfirmation"
                      v-validate="'required|confirmed:password'"
                      data-vv-as="confirm password"
                      name="password_confirmation"
                      class="form-control"
                      :class="{ 'has-danger': getError('password_confirmation') }"
               />
            <label for="confirm">{{ $t('auth.input_confirm_password') }}</label>
              <span v-if="getError('password_confirmation')" class="has-error">{{ getError('password_confirmation') }}</span>
          </span>
          </div>

          <div slot="footer">
            <button class="btn btn-lg btn-primary submit-button" :class="{'disabled': loading}" :disabled="loading" type="submit">{{ $t('auth.btn_update')}}</button>
          </div>
        </form>
        <div>
          <p v-if="submitted && success">
            {{ $t('auth.forgot__password_updated') }}
          </p>

          <p v-if="submitted && !success">
            {{ $t('auth.forgot__password_not_updated') }}
          </p>
        </div>

      </div>
    </div>
    <div class="right-panel">
      <canvas class="strength-indicator" width="628" height="679"></canvas>
    </div>
  </div>
</template>


<script>
  import {PasswordStrengthInit} from "@/helpers";
  import LocaleSwitch from "@/components/LocaleSwitch";
  import {AuthService} from "@/services";

  export default {
    data() {
      return {
        model: {
          email: decodeURIComponent(this.$route.query.email),
          password: '',
          passwordConfirmation: ''
        },
        loading: false,
        submitted: false,
        success: false
      };
    },

    components: {
      LocaleSwitch
    },

    methods: {
      async submitResetPassword() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          this.loading = true;

          await AuthService.submitResetPassword({
            email: this.model.email,
            token: this.$route.params.token,
            password: this.model.password,
            passwordConfirmation: this.model.passwordConfirmation
          }).then((response) => {
            this.success = true;

          }).catch(function (error) {

          })

          this.submitted = true;
          this.loading = false;
        }
      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      }
    },
    mounted() {
      PasswordStrengthInit();
    }
  };
</script>
<style lang="scss" scoped>
  h3 {
    margin-bottom: 7.020833vh;
  }

  .terms-label {
    font-size: 1.62291667vh;
    font-weight: 400;
    margin-top: 2rem;
    color: $secondary;

    &.has-danger {
      a {
        color: $danger;
      }
    }

    a {
      text-decoration: underline;
    }
  }
</style>
